<template>
  <div>
      <v-icon size="180" color="error">far fa-frown</v-icon>
      <h1 class="headline font-weight-medium grey--text my-2">Recuperação de senha não realizada!</h1>
      <h1
        class="text-center subtitle-1 font-weight-medium grey--text my-2 mx-2"
      >Infelizmente, não foi possível finalizar o seu pedido. Por favor tente novamente mais tarde</h1>
      <v-container>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="120"
            height="45"
            depressed
            to="/"
          >Voltar</v-btn>
          <v-spacer></v-spacer>
        </v-layout>
      </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>